import React from "react";
import { AlbumNameEditorProps } from "./types";

const editIcon = require("../../styles/images/edit.svg");
const submitIcon = require("../../../ManagePrepaidCustomers/components/images/submit.svg");
const cancelIcon = require("../../../ManagePrepaidCustomers/components/images/cancel.svg");

const AlbumNameEditor: React.FC<AlbumNameEditorProps> = ({
  albumName,
  selectedAlbum,
  selectedEvent,
  albumsInEditMode,
  updateDraftName,
  handleKeyDownAction,
  submitNameChange,
  toggleEditMode,
  showActionTooltip
}) => {
  const isEditing = albumsInEditMode.includes(selectedAlbum.id);

  if (isEditing) {
    return (
      <div
        className="ws-edit-album-name ws-edit-breadcrumb-album ws-edit-section-padding black-text"
        onClick={e => e.stopPropagation()}
      >
        <textarea
          aria-label="Edit album name"
          defaultValue={albumName || selectedAlbum.name}
          onChange={e => updateDraftName(e, selectedAlbum.id, e.target.value)}
          onKeyDown={e => handleKeyDownAction(e, selectedAlbum)}
          onClick={e => e.stopPropagation()}
          autoFocus
          onFocus={e => {
            const val = e.target.value;
            e.target.value = "";
            e.target.value = val;
          }}
        />
        <div className="ws-edit-album-actions ws-breadrumb-edit-actions">
          <img
            className="actionIcon"
            src={submitIcon}
            alt="Submit changes"
            onClick={e => submitNameChange(e, selectedAlbum)}
          />
          <img
            className="actionIcon"
            style={{ marginLeft: 5 }}
            src={cancelIcon}
            alt="Cancel editing"
            onClick={e =>
              toggleEditMode(
                e,
                selectedAlbum.id,
                false,
                albumName || selectedAlbum.name
              )
            }
          />
        </div>
      </div>
    );
  }

  return (
    <span className="ws-folder-name-div">
      <span
        className="ws-edit-name-h3"
        data-toggle="tooltip"
        data-placement="bottom"
        data-original-title={selectedAlbum?.name}
      >
        {albumName || selectedAlbum.name}
      </span>
      {(
        <span
          className="ws-edit-name-icon"
          data-toggle="tooltip"
          data-placement="top"
          data-container="body"
          title="Edit name"
          id={`edit-icon-${selectedAlbum.id}`}
          onMouseEnter={e =>
            showActionTooltip?.(selectedAlbum.id, "Edit Name", "edit")
          }
          onClick={e =>
            toggleEditMode(
              e,
              selectedAlbum.id,
              true,
              albumName || selectedAlbum.name
            )
          }
        >
          <img src={editIcon} alt="Edit album name" />
        </span>
      )}
    </span>
  );
};

export default AlbumNameEditor;
